(function () {
  if (window.__CartSuccessToastInstalled) return;
  window.__CartSuccessToastInstalled = true;

  let hideTimer = null;

  /* =========================
     Language detection
  ========================= */

  function getLang() {
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    const shopifyLocale =
      window.Shopify && (Shopify.locale || Shopify.language)
        ? String(Shopify.locale || Shopify.language).toLowerCase()
        : "";

    const lang = shopifyLocale || htmlLang || "en";
    return lang.startsWith("ar") ? "ar" : "en";
  }

  /* =========================
     Translations
  ========================= */

  const i18n = {
    en: {
      success: "Success",
      updated: "Cart successfully updated",
    },
    ar: {
      success: "تم بنجاح",
      updated: "تم تحديث السلة بنجاح",
    },
  };

  /* =========================
     Create toast element
  ========================= */

  function ensureToastEl() {
    let el = document.querySelector(".cart-success-toast");
    if (el) return el;

    el = document.createElement("div");
    el.className = "cart-success-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");

    el.innerHTML = `
      <div class="cart-success-toast__topbar"></div>
      <div class="cart-success-toast__body">
        <div class="cart-success-toast__text">
          <div class="cart-success-toast__title"></div>
          <div class="cart-success-toast__sub"></div>
        </div>

        <div class="cart-success-toast__icon">
          <svg viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </div>
      </div>
    `;

    document.body.appendChild(el);
    return el;
  }

  /* =========================
     Show toast
  ========================= */

  function showToast({ title, sub, duration = 1400 }) {
    const el = ensureToastEl();

    const titleEl = el.querySelector(".cart-success-toast__title");
    const subEl = el.querySelector(".cart-success-toast__sub");
    const bar = el.querySelector(".cart-success-toast__topbar");

    titleEl.textContent = title;
    subEl.textContent = sub;

    // restart progress animation
    const newBar = bar.cloneNode(true);
    bar.parentNode.replaceChild(newBar, bar);

    el.style.setProperty("--toast-duration", duration + "ms");

    el.classList.add("is-open");

    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      el.classList.remove("is-open");
    }, duration + 250);
  }

  /* =========================
     Public function
  ========================= */

  window.showCartSuccessToast = function () {
    const lang = getLang();

    showToast({
      title: i18n[lang].success,
      sub: i18n[lang].updated,
      duration: 1400,
    });
  };

  /* =========================
     Detect add-to-cart calls
  ========================= */

  const originalFetch = window.fetch;

  window.fetch = async function (input, init) {
    const url =
      typeof input === "string"
        ? input
        : input && input.url
        ? input.url
        : "";

    const isCartAdd =
      typeof url === "string" &&
      (url.includes("/cart/add.js") || url.includes("/cart/add"));

    const res = await originalFetch(input, init);

    try {
      if (isCartAdd && res && res.ok) {
        window.showCartSuccessToast();
      }
    } catch (e) {}

    return res;
  };
})();